export const USER_SCOPES = {
    LANDLORD: 'am-landlord',
    TENANT: 'am-tenant',
    ADMIN: 'admin'
};
